// eslint-disable-next-line @github-ui/github-monorepo/filename-convention
import {SkipIcon} from '@primer/octicons-react'

import {ICONS_VALUES} from './values'

export function getIssueStateIcon(stateOrReason: string | null) {
  let issueState = {
    color: 'var(--fgColor-muted)',
    icon: SkipIcon,
    description: ICONS_VALUES.issueIcons.NOT_PLANNED.description,
  }
  if (stateOrReason) {
    const stateKey = `${stateOrReason}` as keyof typeof ICONS_VALUES.issueIcons
    if (stateKey in ICONS_VALUES.issueIcons) {
      issueState = ICONS_VALUES.issueIcons[stateKey]
    } else if (stateOrReason !== 'COMPLETED') {
      throw new Error('Invalid state reason')
    }
  }
  return issueState
}

export type PullRequestStateIconKey = keyof typeof ICONS_VALUES.pullRequestIcons

export function getPullRequestStateIcon(state: string | null) {
  if (!state) {
    return {
      color: 'var(--fgColor-muted)',
      icon: SkipIcon,
      description: ICONS_VALUES.pullRequestIcons.DRAFT.description,
    }
  }

  const stateKey = `${state}` as keyof typeof ICONS_VALUES.pullRequestIcons
  if (stateKey in ICONS_VALUES.pullRequestIcons) {
    return ICONS_VALUES.pullRequestIcons[stateKey]
  }

  throw new Error('Invalid state reason')
}

export function getPullRequestEntityState(
  isArchived: boolean,
  isDraft: boolean,
  isInMergeQueue: boolean,
  state: string,
): PullRequestStateIconKey {
  if (isInMergeQueue) return 'IN_MERGE_QUEUE'
  if (isArchived) return 'ARCHIVED'
  if (isDraft && state === 'OPEN') return 'DRAFT'

  if (Object.hasOwn(ICONS_VALUES.pullRequestIcons, state)) {
    return state as PullRequestStateIconKey
  }

  throw new Error(`Invalid pull request state: ${state}`)
}
